import React from "react"

import Markdown from "@components/Markdown"
import confirmAction from "@components/Page/helpers/confirmAction"

import useSignInAs from "./useSignInAs"


const getSignInAsConfirm = (modal, request, identity, account) => {
  const { investor: { givenName, familyName } } = account
  const fullName = `${givenName} ${familyName}`

  const signInAsInvestor = useSignInAs(account, request, identity)

  return () =>
    confirmAction(
      modal,
      "Login",
      "Login As",
      <Markdown text={`You are about to open the investor portal in a new tab as **${fullName}**.`} />,
      signInAsInvestor,
    )
}

export default getSignInAsConfirm
